import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useState } from 'react';
import { OTBoilerStates, } from 'console/shared/components/dialogs/ot-boiler-state';
import { SortableCards } from 'console/shared/components/features/sortable-cards';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { Z3KExternalPanel } from './thumblers/z3k/external-panel';
import { BoilerHeatingCircuitCard } from './boiler-heating-circuit-card';
import { BoilerHeatingCircuitProvider } from './boiler-heating-circuit-card/provider';
import { usePartial } from 'shared/hooks/utils';
export const BoilersHeatingCircuits = memo(function BoilersHeatingCircuits(props) {
    const { config, panel_key } = props;
    const { device_id } = useContext(DeviceConfig);
    const [open_id, setOpenId] = useState(null);
    const [open_therm_states, setOpenThermStates] = useState([]);
    const onClose = usePartial(setOpenId, null);
    const component = useCallback((config) => (_jsx(BoilerHeatingCircuitProvider, { boiler_heating_circuit_config: config, setOpenThermStates: setOpenThermStates, children: _jsx(BoilerHeatingCircuitCard, { onClick: setOpenId }) }, config.id)), []);
    return (_jsxs(_Fragment, { children: [_jsx(SortableCards, { panel_key: panel_key, list: config, component: component }), open_id != null && (_jsx(OTBoilerStates, { open_id: open_id, onClose: onClose, heating_circuits: open_therm_states })), _jsx(Z3KExternalPanel, { device_id: device_id })] }));
});
